import axios from 'axios';
import { useQuery } from 'react-query';
import { Cases } from '../api/responses';

export const useGetCases = (
  page: number,
  isEnable: boolean,
  selectedTagsIds: number[],
  debouncedQuery?: string,
  lang?: number | null,
  type?: string
) => {
  const getCases = async (): Promise<Cases> => {
    const params: any = {
      page: page,
      page_size: 10,
    };

    if (lang) {
      params['language'] = lang;
    }
    if (type) {
      params['game_type'] = type;
    }

    if (debouncedQuery) {
      params['query'] = debouncedQuery.trim();
    }

    let tagsFilter = '';
    if (selectedTagsIds.length) {
      tagsFilter = `?tags=${selectedTagsIds}`;
    }

    const cases = await axios
      .get(`${process.env.REACT_APP_API_URL}/cases/${tagsFilter}`, {
        params,
      })
      .then((res) => res.data);
    return cases;
  };

  const { data, isLoading, isError, error, isFetching, refetch } = useQuery({
    queryKey: [
      'get-cases',
      { page, type, lang, debouncedQuery, tags: selectedTagsIds.join() },
    ],
    queryFn: getCases,
    enabled: isEnable,
    retry: 3,
  });

  return { data, isError, isLoading, error, isFetching, refetch };
};
